<template>
        <div v-if="hasInstructions" class="instructions-card p-4 ms-3">
            <h5>Instructions</h5>

            <div ref="instructionContainer"
                v-html="savedFormData.data.entity_details[0].custom_text"
                :class="['instruction-content', { collapsed: !showFullInstructions }]"
            ></div>

            <div v-if="!showFullInstructions" class="fade-overlay"></div>

                <p @click="toggleInstructions" class="text-danger fw-bold mb-0 mt-2" style="cursor: pointer;">
                    {{ showFullInstructions ? 'Show Less' : 'Read More...' }}
                </p>
            </div>

</template>
<script>
export default {
  props: ['currentStep'],
  data() {
    return {
      savedFormData: null,
      showFullInstructions: true
    };
  },
  computed: {
    hasInstructions() {
      const customText = this.savedFormData?.data?.entity_details?.[0]?.custom_text;
      return customText && customText.trim() !== '';
    }
  },
  methods: {
    toggleInstructions() {
      this.showFullInstructions = !this.showFullInstructions;
    }
  },
  mounted() {
    const saved = localStorage.getItem('form_response');
    this.savedFormData = saved ? JSON.parse(saved) : null;
  }
};
</script>
<style>
.instruction-content.collapsed {
  max-height: 180px;
  overflow: hidden;
  position: relative;
}

.fade-overlay {
  margin-top: -2.5rem;
  height: 60px;
  background: linear-gradient(to bottom, transparent, white);
  pointer-events: none;
  position: relative;
  z-index: 1;
}

</style>